import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import ReactQuill, { Quill } from 'react-quill-new'
import 'react-quill-new/dist/quill.snow.css'

interface EditableInputProps {
  title: string
  value: string
  setValue: (value: string) => void
}

const Size = Quill.import('formats/size')
Size.whitelist = ['small', false, 'large', 'huge'] // false é o padrão (normal)
Quill.register(Size, true)

export function EditableInput({
  title,
  value,
  setValue,
}: EditableInputProps) {
  return (
    <Box sx={{ pb: 2 }}>
      <Typography variant="caption" gutterBottom sx={{ px: 2 }}>
        {title}
      </Typography>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={setValue}
        style={{ height: 200, marginBottom: 20 }}
        modules={{
          toolbar: [
            [{ size: ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'bullet' }, { list: 'ordered' }],
            ['clean'],
          ],
        }}
      />
    </Box>
  )
}
